import { Component,OnInit,OnDestroy,AfterViewInit,Input } from "@angular/core";
import { NgbModal,NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { takeWhile } from "rxjs/operators";

import {
    FvmsCommonService
    ,FvmsApiDtgTeamService
    ,FvmsApiAuthService
    ,FvmsMapApiProvidor
    ,FvmsApiDtgGeoFenceService
} from "src/app/shared/service";
import {
    DtgActionType
} from "src/app/shared/vo";
import {
    ModalAddrSearchComponent
} from "src/app/shared/components";

@Component({
    templateUrl: "./geofence.conf.form.component.html"
    ,providers: []
})
export class GeofenceConfFormComponent implements OnInit,OnDestroy,AfterViewInit {
    isContinue:boolean = true;
    @Input() companyId:string;
    @Input() teamId:string;
    @Input() geoFenceId:string;
    @Input() dtgActionType:DtgActionType;
    formGroup: FormGroup;
    submitted:boolean = false;
    readOnly:boolean = true;
    DtgActionType = DtgActionType;
    currentUserInfo:any;
    userGroupId:number;
    listTeam:any[];
    mapService:any;
    strokeColor = "#00a0e9";
    fillColor = "#00a0e9";
    strokeWeight = 3;
    isDrawing:boolean = false;
    listGeofenceConf:any[] = [];
    mapPolygon:any;
    circleRadiusLine:any;
    mapBounds:any;
    distanceOverlay:any;

    constructor(
        private modalService: NgbModal
        ,public activeModal: NgbActiveModal
        ,private formBuilder: FormBuilder
        ,private fvmsApiDtgTeamService:FvmsApiDtgTeamService
        ,private fvmsApiAuthService:FvmsApiAuthService
        ,private fvmsMapApiProvidor:FvmsMapApiProvidor
        ,private fvmsApiDtgGeoFenceService:FvmsApiDtgGeoFenceService
    ) {
        this.currentUserInfo = this.fvmsApiAuthService.getLoginUserInfo();
        this.userGroupId = parseInt(this.currentUserInfo.userGroupId);
        this.mapService = this.fvmsMapApiProvidor.getMapApiService();
     }

    ngOnInit() {
        this.initForm();
        this.mapService.initMapContainer("map-container-01");
        this.mapService.addControlViewMode();
        this.mapService.addControlZoom();
        this.mapService.addControlCopyright();
        this.mapService.initLatLngBounds();
        this.mapService.initGeocoder();
        this.clearMap();
        this.initMap();
        switch(this.dtgActionType){
            case DtgActionType.create:
                this.readOnly = false;
                break;
            case DtgActionType.update:
            case DtgActionType.delete:
                this.readOnly = false;
                this.selectOneGeofenceInfo();
                break;
            case DtgActionType.read:
            default:
                this.readOnly = true;
                this.selectOneGeofenceInfo();
                this.formGroup.disable();
                break;
        }
        this.reloadListItemTeam();
    }

    ngOnDestroy() {
        this.isContinue = false;
    }
    
    ngAfterViewInit() {
        
    }

    initForm(){
        this.formGroup = this.formBuilder.group({
            geoFenceId:this.geoFenceId
            ,companyId:[
                this.companyId
                ,[
                    Validators.required
                ]
            ]
            ,companyNm:null
            ,dtgTeamId:null
            ,dtgTeamNm:null
            ,geoFenceNm:[
                null
                ,[
                    Validators.required
                ]
            ]
            ,runType:"S"
            ,shapeType:[
                "C"
                ,[
                    Validators.required
                ]
            ]
            ,routeType:[
                "X"
                ,[
                    Validators.required
                ]
            ]
            ,baseLat:null
            ,baseLng:null
            ,baseAddr:null
            ,eventTimeLimitSec:"300"
            ,useYn:"Y"
        });
    }

    get f() { return this.formGroup.controls; }

    selectOneGeofenceInfo(){
        let searchInfo = {
            companyId : this.companyId
            // ,dtgTeamId : this.teamId
            ,geoFenceId : this.geoFenceId
        };
        this.fvmsApiDtgGeoFenceService.listGeoFenceConfLoc(searchInfo)
            .pipe(takeWhile(() => this.isContinue))
            .subscribe(apiResponse => {
                if(apiResponse.resultStatus === "ok"){
                    //this.formGroup.patchValue(apiResponse.resultValue);
                    if(apiResponse.resultValue && apiResponse.resultValue.length > 0){
                        let info = apiResponse.resultValue[0];
                        this.formGroup.patchValue(info);
                        for(let a=0;a<apiResponse.resultValue.length;a++){
                            let tmpItem = apiResponse.resultValue[a];
                            if(tmpItem.lat && tmpItem.lng){
                                this.listGeofenceConf.push({
                                    lat:tmpItem.lat
                                    ,lng:tmpItem.lng
                                    ,radius:tmpItem.radius
                                });
                            }
                        }
                        this.drawFromConf();
                    }
                }
            });
    }

    // 셀렉트박스 그룹목록
    reloadListItemTeam(){
        let searchInfo = {
            companyId : this.companyId
            ,dtgTeamId : this.currentUserInfo.teamId
            ,searchValue : null
        };
        let pagingInfoTeam = {
            "curPage":1
            ,"pageSize":1000
        };
        this.fvmsApiDtgTeamService.getListTeam(searchInfo,pagingInfoTeam)
            .pipe(takeWhile(() => this.isContinue))
            .subscribe(apiResponse => {
                if(apiResponse.resultStatus === "ok"){
                    this.listTeam = apiResponse.resultValue;
                }
            });
    }

    clickCancel(){
        this.activeModal.close({
            "result":"cancel"
        });
    }

    clickSave(){
        this.onSubmit();
    }

    // 원형/사각형/다각형 설정 변경시
    changeShapeType(event){
        if(this.isDrawing){
            //그리는중
            this.isDrawing = false;
            this.clearMap();
        }
    }

    changeRouteType(event){
        switch(this.f.routeType.value){
            case "C":
            case "c":
                // 차고지
                break;
            case "P":
            case "p":
                // 경유지
                break;
            case "X":
            case "x":
            default:
                // 일반
                break;
        }
    }

    clickOpenModalAddrSearch(){
        let modalRef = this.modalService.open(
            ModalAddrSearchComponent
            ,{
                centered:true
                // ,size: "xl"
                ,backdrop:"static"
                //windowClass: "dark-modal"
                ,scrollable: true
            }
        );
        modalRef.componentInstance.dtgActionType = DtgActionType.read;
        modalRef.componentInstance.inAddr = this.f.baseAddr.value;

        modalRef.result.then((resultModal) => {
            if(resultModal.result === "ok"){
                // patch addr
                if(resultModal.addr){
                    this.formGroup.patchValue({baseAddr:resultModal.addr});
                    this.mapService.searchAddrByAddr(resultModal.addr)
                        .then((latLng) => {
                            this.formGroup.patchValue({
                                baseLat:latLng.getLat()
                                ,baseLng:latLng.getLng()
                            });
                            this.mapService.getMapObject().setCenter(latLng);
                            this.mapService.getMapObject().setLevel(1);
                        });
                }
            }
        });
    }

    onSubmit(){
        this.submitted = true;
        // console.log("onSubmit",this.f);
        if (this.formGroup.invalid) {
            return;
        }

        let searchInfo = {
            geoFenceId:this.f.geoFenceId.value
            ,companyId:this.f.companyId.value
            ,dtgTeamId:this.f.dtgTeamId.value
            ,geoFenceNm:this.f.geoFenceNm.value
            ,runType:this.f.runType.value
            ,shapeType:this.f.shapeType.value
            ,routeType:this.f.routeType.value
            ,baseLat:this.f.baseLat.value
            ,baseLng:this.f.baseLng.value
            ,baseAddr:this.f.baseAddr.value
            ,eventTimeLimitSec:this.f.eventTimeLimitSec.value
            ,useYn:this.f.useYn.value
            ,listLatLng:this.listGeofenceConf
            ,createUser:this.currentUserInfo.userId
            ,updateUser:this.currentUserInfo.userId
        };
        this.fvmsApiDtgGeoFenceService.upsertGeoFenceConf(searchInfo)
            .pipe(takeWhile(() => this.isContinue))
            .subscribe(apiResponse => {
                if(apiResponse.resultStatus === "ok"){
                    console.log("new geoFenceId",apiResponse.resultValue.geoFenceId);
                }

                this.activeModal.close({
                    "result":"ok"
                });
            });
    }

    // -------------------------------------------------- Drawing Start
    clearMap(){
        this.listGeofenceConf = [];
        if(this.mapPolygon){
            this.mapPolygon.setMap(null);
        }
        if(this.distanceOverlay){
            this.distanceOverlay.setMap(null);
        }
        if(this.circleRadiusLine){
            this.circleRadiusLine.setMap(null);
        }
        this.mapService.initLatLngBounds();
        this.mapBounds = this.mapService.getMapLatLngBounds();
        // $("#area_radius").val("");
        // $("#area_lat_lng").val("");
    }

    initMap(){
        let self = this;
        switch(this.dtgActionType){
            case this.DtgActionType.read:
                // 상세보기에는 이벤트를 구성 할 필요 없다
                break;
            default:
                this.mapService.addMapEvent("click",(event) => self.clickMap(event,self));
                this.mapService.addMapEvent("mousemove",(event) => self.moveMap(event,self));
                this.mapService.addMapEvent("rightclick",(event) => self.clickRightMap(event,self));
                break;
        }
    }

    drawFromConf(){
        // this.clearMap();
        switch(this.f.shapeType.value){
            case "P":
            case "p":
                this.drawPolygonFromConf();
                break;
            case "R":
            case "r":
                this.drawRectangleFromConf();
                break;
            case "C":
            case "c":
            default:
                this.drawCircleFromConf();
                break;
        }
        switch(this.dtgActionType){
            case DtgActionType.read:
                this.mapService.getMapObject().setDraggable(false);
                break;
            default:
                break;
        }
    }

    drawCircleFromConf(){
        this.drawStartCircle();
        this.drawingCircle();
        this.drawDistInfo();
        this.drawEndCircle();
    }

    drawRectangleFromConf(){
        this.drawStartRectangle();
        this.drawingRectangle();
        this.drawEndRectangle();
    }

    drawPolygonFromConf(){
        this.drawStartPolygon();
        this.drawingPolygon();
        this.drawEndPolygon();
    }

    clickMap(mouseEvent:any,self:any){
        let clickPosition = mouseEvent.latLng;
        let clickConf = {
            lat:clickPosition.getLat()
            ,lng:clickPosition.getLng()
            ,radius:0
        };

        if(this.isDrawing){
            //그리는중
        }else{
            //그리기 종료 후 다시 click
            this.clearMap();
        }

        switch(this.f.shapeType.value){
            case "P":
            case "3":
            case 3:
                // 다각
                if(this.isDrawing){
                    //그리는중
                    this.listGeofenceConf.push(clickConf);
                    // this.drawingPolygon();
                }else{
                    //그리기 종료 후 click
                    this.isDrawing = true;
                    this.listGeofenceConf.push(clickConf);
                    this.drawStartPolygon();
                }
                break;
            case "R":
            case "2":
            case 2:
                // 사각
                if(this.isDrawing){
                    //그리는중
                }else{
                    //그리기 종료 후 click
                    this.isDrawing = true;
                    this.listGeofenceConf.push(clickConf);
                    this.drawStartRectangle();
                }
                break;
            case "C":
            case "1":
            case 1:
            default:
                // 원
                if(this.isDrawing){
                    //그리는중
                }else{
                    //그리기 종료 후 click
                    this.isDrawing = true;
                    this.listGeofenceConf.push(clickConf);
                    this.drawStartCircle();
                    this.drawStartCircleRadiusLine();
                    this.drawDistInfo();
                }
                break;
        }
    }

    moveMap(mouseEvent:any,self:any){
        let clickPosition = mouseEvent.latLng;
//         console.log("mousemove",clickPosition.getLat(),clickPosition.getLng());
        let clickConf = {
            lat:clickPosition.getLat()
            ,lng:clickPosition.getLng()
        };

        if(this.isDrawing){
            //그리는중
        }else{
            //그리기 종료 후 click
        }
        
        switch(this.f.shapeType.value){
            case "P":
            case "3":
            case 3:
                // 다각
                if(this.isDrawing){
                    //그리는중
                    if(this.listGeofenceConf.length > 1){
                        this.listGeofenceConf.pop();
                    }
                    this.listGeofenceConf.push(clickConf);
                    this.drawingPolygon();
                }else{
                    //그리기 종료 후 move
                }
                break;
            case "R":
            case "2":
            case 2:
                // 사각
                if(this.isDrawing){
                    //그리는중
                    if(this.listGeofenceConf.length > 1){
                        this.listGeofenceConf[1] = clickConf;
                    }else{
                        this.listGeofenceConf.push(clickConf);
                    }
                    this.drawingRectangle();
                }else{
                    //그리기 종료 후 move
                }
                break;
            case "C":
            case "1":
            case 1:
            default:
                // 원
                if(this.isDrawing){
                    //그리는중
                    if(this.listGeofenceConf.length > 1){
                        this.listGeofenceConf[1] = clickConf;
                    }else{
                        this.listGeofenceConf.push(clickConf);
                    }
                    this.drawingCircle();
                    this.drawEndCircleRadiusLine();
                    this.drawDistInfo();
                }else{
                    //그리기 종료 후 move
                }
            break;
        }
    }

    clickRightMap(mouseEvent:any,self:any){
        // console.log("clickRightMap",mouseEvent);
        let clickPosition = mouseEvent.latLng;
//         console.log("rightclick",clickPosition.getLat(),clickPosition.getLng());
        let clickConf = {
            lat:clickPosition.getLat()
            ,lng:clickPosition.getLng()
        };
        
        if(this.isDrawing){
            //그리는중
        }else{
            //그리기 종료 후 click
        }
        
        switch(this.f.shapeType.value){
            case "P":
            case "3":
            case 3:
                if(this.isDrawing){
                    //그리는중
                    this.isDrawing = false;
                    this.drawEndPolygon();
                    let mapCenterLatLng = this.mapService.getCenter();
                    this.formGroup.patchValue({
                        baseLat:mapCenterLatLng.getLat()
                        ,baseLng:mapCenterLatLng.getLng()
                    });
                    this.mapService.searchAddrByLatLng(mapCenterLatLng.getLat(),mapCenterLatLng.getLng())
                        .then((addr) => {
                            this.formGroup.patchValue({
                                baseAddr:addr
                            });
                        });
                }else{
                    //그리기 종료 후 move
                }
                break;
            case "R":
            case "2":
            case 2:
                if(this.isDrawing){
                    //그리는중
                    this.isDrawing = false;
                    this.drawEndRectangle();
                    let mapCenterLatLng = this.mapService.getCenter();
                    this.formGroup.patchValue({
                        baseLat:mapCenterLatLng.getLat()
                        ,baseLng:mapCenterLatLng.getLng()
                    });
                    this.mapService.searchAddrByLatLng(mapCenterLatLng.getLat(),mapCenterLatLng.getLng())
                        .then((addr) => {
                            this.formGroup.patchValue({
                                baseAddr:addr
                            });
                        });
                }else{
                    //그리기 종료 후 move
                }
                break;
            case "C":
            case "1":
            case 1:
            default:
                if(this.isDrawing){
                    //그리는중
                    this.isDrawing = false;
                    this.drawEndCircle();
                    let mapCenterLatLng = this.mapService.getCenter();
                    this.formGroup.patchValue({
                        baseLat:mapCenterLatLng.getLat()
                        ,baseLng:mapCenterLatLng.getLng()
                    });
                    this.mapService.searchAddrByLatLng(mapCenterLatLng.getLat(),mapCenterLatLng.getLng())
                        .then((addr) => {
                            this.formGroup.patchValue({
                                baseAddr:addr
                            });
                        });
                }else{
                    //그리기 종료 후 move
                }
                break;
        }
    }

    // ------------------------------------------------------------ Circle Start
    // 원형 그리기 시작 - click
    drawStartCircle(){
        let centerConf = this.listGeofenceConf[0];
        let centerPosition = this.mapService.createLatLng(centerConf.lat,centerConf.lng);
        centerConf.radius *= 1;

        this.mapPolygon = this.mapService.createCircle({
            center : centerPosition // 원의 중심좌표입니다
            ,radius: centerConf.radius // 원의 반지름입니다 m 단위 이며 선 객체를 이용해서 얻어옵니다
            ,strokeWeight: this.strokeWeight // 선의 두께입니다
            ,strokeColor: this.strokeColor // 선의 색깔입니다
            ,strokeOpacity: 1 // 선의 불투명도입니다 0에서 1 사이값이며 0에 가까울수록 투명합니다
            ,strokeStyle: "solid" // 선의 스타일입니다
            ,fillColor: this.fillColor // 채우기 색깔입니다
            ,fillOpacity: 0.2  // 채우기 불투명도입니다 
        });
        this.mapPolygon.setMap(this.mapService.getMapObject());
    }

    // 원의 반지름선 시작점 - click
    drawStartCircleRadiusLine(){
        let centerConf = this.listGeofenceConf[0];
        let centerPosition = this.mapService.createLatLng(centerConf.lat,centerConf.lng);

        this.circleRadiusLine = this.mapService.createPolyLine({
            strokeWeight: this.strokeWeight // 선의 두께입니다
            ,strokeColor: this.strokeColor // 선의 색깔입니다
            ,strokeOpacity: 1 // 선의 불투명도입니다 0에서 1 사이값이며 0에 가까울수록 투명합니다
            ,strokeStyle: "solid" // 선의 스타일입니다
            ,linePath : [centerPosition]
        });
        this.circleRadiusLine.setMap(this.mapService.getMapObject());
    }

    // 반경 정보를 생성
    drawDistInfo(){
        let radius = this.getCircleRadiusLineDist();
        let content = '<div class="badge badge-info mt-2 ml-2">반경 <span class="">' + Math.round(radius) + '</span>m</div>';
        let centerConf = this.listGeofenceConf[0];
        let position = this.mapService.createLatLng(centerConf.lat,centerConf.lng);
        
        if(this.distanceOverlay){
            this.distanceOverlay.setPosition(position);
            this.distanceOverlay.setContent(content);
        }else{
            this.distanceOverlay = this.mapService.createCustomOverlay({
                content: content  // 커스텀오버레이에 표시할 내용입니다
                ,position: position // 커스텀오버레이를 표시할 위치입니다.
                ,xAnchor: 0
                ,yAnchor: 0
                ,zIndex: 3
            });
        }
        this.distanceOverlay.setMap(this.mapService.getMapObject());
    }

    // 반지름 계산
    getCircleRadiusLineDist(){
        let dist = 0;
        if(this.circleRadiusLine){
            if(this.circleRadiusLine.getPath().length > 1){
                dist = this.circleRadiusLine.getLength();
            }
        }
        if(!dist){
            dist = this.listGeofenceConf[0].radius;
        }
        dist *= 1;
        return dist || 0;
    }

    // 마우스를 따라 원을 그린다 - move
    drawingCircle(){
        let centerConf = this.listGeofenceConf[0];
        let centerPosition = this.mapService.createLatLng(centerConf.lat,centerConf.lng);
        let radius = this.getCircleRadiusLineDist();

        this.mapPolygon.setPosition(centerPosition);
        this.mapPolygon.setRadius(radius);
        this.mapPolygon.setMap(this.mapService.getMapObject());
    }

    // 마우스를 따라 반지름 선을 그린다 - move
    drawEndCircleRadiusLine(){
        let centerConf = this.listGeofenceConf[0];
        let centerPosition = this.mapService.createLatLng(centerConf.lat,centerConf.lng);
        let endConf = this.listGeofenceConf[1];
        let endPosition = this.mapService.createLatLng(endConf.lat,endConf.lng);
        this.circleRadiusLine.setPath([centerPosition,endPosition]);
        this.circleRadiusLine.setMap(this.mapService.getMapObject());
    }

    // 마우스 우클릭으로 그리기를 종료한다 - rightclick
    drawEndCircle(){
        let centerConf = this.listGeofenceConf[0];
        let centerPosition = this.mapService.createLatLng(centerConf.lat,centerConf.lng);
        let radius = this.getCircleRadiusLineDist();

        this.mapService.getMapObject().setCenter(centerPosition);

        let bounds = this.mapPolygon.getBounds();
        let lat_lng1 = bounds.getNorthEast().toString().replace("(","").replace(")","").split(",");
        let lat_lng2 = bounds.getSouthWest().toString().replace("(","").replace(")","").split(",");
        this.mapBounds.extend(this.mapService.createLatLng(lat_lng1[0], lat_lng1[1]));
        this.mapBounds.extend(this.mapService.createLatLng(lat_lng2[0], lat_lng2[1]));
        this.mapService.getMapObject().setBounds(this.mapBounds);
        
        this.listGeofenceConf[0].radius = radius;
        if(this.listGeofenceConf.length > 1){
            this.listGeofenceConf.pop();
        }
        // $("#area_radius").val(radius);
        let area_lat_lng = centerPosition.toString().replace(/[\(\)\s]+/g,"");
        // $("#area_lat_lng").val(area_lat_lng);
        console.log("drawEndCircle",radius,centerConf.lat,centerConf.lng);
    }
    // ------------------------------------------------------------ Circle End

    // ------------------------------------------------------------ Rectangle Start
    // 사각형 그리기 시작 - click
    drawStartRectangle(){
        let centerConf = this.listGeofenceConf[0];
        let centerPosition = this.mapService.createLatLng(centerConf.lat,centerConf.lng);
        let rectangleBounds = this.mapService.createLatLngBounds(centerPosition,centerPosition);//sw,ne(남서,북동)

        this.mapPolygon = this.mapService.createRectangle({
             strokeWeight: this.strokeWeight // 선의 두께입니다
            ,strokeColor: this.strokeColor // 선의 색깔입니다
            ,strokeOpacity: 1 // 선의 불투명도입니다 0에서 1 사이값이며 0에 가까울수록 투명합니다
            ,strokeStyle: 'solid' // 선의 스타일입니다
            ,fillColor: this.fillColor // 채우기 색깔입니다
            ,fillOpacity: 0.2  // 채우기 불투명도입니다 
        });
        this.mapPolygon.setBounds(rectangleBounds);
        this.mapPolygon.setMap(this.mapService.getMapObject());
    }

    // 마우스를 따라 사각형을 그린다 - move
    drawingRectangle(){
        let listLatLng = [];
        let rectangleBounds = this.mapService.createLatLngBounds();
        
        for(let a=0;a<this.listGeofenceConf.length;a++){
            let tmpConf = this.listGeofenceConf[a];
            let tmpLatLng = this.mapService.createLatLng(tmpConf.lat,tmpConf.lng);
            listLatLng.push(tmpLatLng);
            rectangleBounds.extend(tmpLatLng);
        }

        this.mapPolygon.setBounds(rectangleBounds);
        this.mapPolygon.setMap(this.mapService.getMapObject());
    }

    // 마우스 우클릭으로 그리기를 종료한다 - rightclick
    drawEndRectangle(){
        let listLatLng = [];
        let rectangleBounds = this.mapService.createLatLngBounds();
        
        for(let a=0;a<this.listGeofenceConf.length;a++){
            let tmpConf = this.listGeofenceConf[a];
            this.listGeofenceConf[a].radius = 0;
            let tmpLatLng = this.mapService.createLatLng(tmpConf.lat,tmpConf.lng);
            listLatLng.push(tmpLatLng);
            rectangleBounds.extend(tmpLatLng);
        }

        let area_lat_lng = listLatLng.join(";").replace(/[\(\)\s]+/g,"");
        // $("#area_lat_lng").val(area_lat_lng);
        console.log("drawEndRectangle",area_lat_lng);

        this.mapService.getMapObject().setBounds(rectangleBounds);
        let mapCenter = this.mapService.getMapObject().getCenter();
    }
    // ------------------------------------------------------------ Rectangle End

    // ------------------------------------------------------------ Polygon Start
    // 다각형 그리기 시작 - click
    drawStartPolygon(){
        let startConf = this.listGeofenceConf[0];
        console.log("drawStartPolygon",startConf);
        let startPosition = this.mapService.createLatLng(startConf.lat,startConf.lng);

        this.mapPolygon = this.mapService.createPolygon({
             strokeWeight: this.strokeWeight // 선의 두께입니다
            ,strokeColor: this.strokeColor // 선의 색깔입니다
            ,strokeOpacity: 1 // 선의 불투명도입니다 0에서 1 사이값이며 0에 가까울수록 투명합니다
            ,strokeStyle: 'solid' // 선의 스타일입니다
            ,fillColor: this.fillColor // 채우기 색깔입니다
            ,fillOpacity: 0.2  // 채우기 불투명도입니다 
        });
        this.mapPolygon.setPath([startPosition]);
        this.mapPolygon.setMap(this.mapService.getMapObject());
    }

    // 마우스를 따라 다각형을 그린다 - move
    drawingPolygon(){
        let listLatLng = [];

        for(let a=0;a<this.listGeofenceConf.length;a++){
            let tmpConf = this.listGeofenceConf[a];
            let tmpLatLng = this.mapService.createLatLng(tmpConf.lat,tmpConf.lng);
            listLatLng.push(tmpLatLng);
        }

        this.mapPolygon.setPath(listLatLng);
        this.mapPolygon.setMap(this.mapService.getMapObject());
    }

    // 마우스 우클릭으로 그리기를 종료한다 - rightclick
    drawEndPolygon(){
        let listLatLng = [];
        let polygonBounds = this.mapService.createLatLngBounds();

        for(let a=0;a<this.listGeofenceConf.length;a++){
            let tmpConf = this.listGeofenceConf[a];
            this.listGeofenceConf[a].radius = 0;
            let tmpLatLng = this.mapService.createLatLng(tmpConf.lat,tmpConf.lng);
            listLatLng.push(tmpLatLng);
            polygonBounds.extend(tmpLatLng);
        }

        let area_lat_lng = listLatLng.join(";").replace(/[\(\)\s]+/g,"");
        // $("#area_lat_lng").val(area_lat_lng);
        console.log("drawEndPolygon",area_lat_lng);

        this.mapService.getMapObject().setBounds(polygonBounds);
        let mapCenter = this.mapService.getMapObject().getCenter();
    }
    // ------------------------------------------------------------ Polygon End

    // -------------------------------------------------- Drawing End
}